import {DocumentNode, gql} from "@apollo/client";

export const UPDATE_PROFILE_MUTATION: DocumentNode = gql(`
    mutation UpdateProfile($dto: UserUpdateRequest!) {
        updateProfile(updateProfileDto: $dto) {
            ...UserInfo
        }
    }
`);
